module.exports = __webpack_public_path__ + "fonts/effect-cybernetics-tactics-a1b865.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-cybernetics-tactics.svg
// module id = 734
// module chunks = 0